<template>
  <a-modal
    :closable="false"
    :footer="null"
    v-model="visible"
    width="1080px"
    destroyOnClose
    @cancel="handleClose"
    wrapClassName="conversation"
  >
    <a-row type="flex" justify="start" align="top" style="height:603px;">
      <a-col span="6" style="height:100%;overflow:hidden">
        <conversation-list></conversation-list>
      </a-col>
      <a-col span="18" style="height:100%;">
        <current-conversation v-if="currentConversation.conversationID"></current-conversation>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import Api from "@/api";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("im");
import BaseModal from "@/components/base-modal.vue";
import ConversationList from "./conversation-list";
import CurrentConversation from "./current-conversation";

export default {
  name: "c2c",
  extends: BaseModal,
  provide() {
    return {
      closeConversation: this.closeConversation
    };
  },
  computed: {
    ...mapState(["c2cConversationList", "currentConversation"])
  },
  components: { ConversationList, CurrentConversation },
  methods: {
    ...mapActions(["checkoutConversation"]),
    async show(conversationID, hunter) {
      //初始化一个会话
      if(conversationID) {
        await this.checkoutConversation(conversationID);
        this.open();
      } else {
        if (!this.currentConversation.conversationID && this.c2cConversationList.length > 0) {
          this.checkoutConversation(this.c2cConversationList[0].conversationID);
        }
        this.open();
      }
    },
    closeConversation() {
      this.close();
      this.handleClose();
    },
    handleClose() {
      this.postcard = false;
    }
  }
};
</script>

<style lang="scss">
.conversation {
  .ant-modal-content {
    border-radius: 0;
    position: relative;
    .ant-modal-body {
      padding: 0;
      background: #f5f5f5;
    }
  }
}
</style>
